<template>
  <lwf-autocomplete
    :value="value"
    :options="customers"
    v-bind="vAttrs"
    :readonly="readonly"
    v-on="vListeners"
  >
    <template #option="scope">
      <q-item
        v-ripple
        v-bind="scope.itemProps"
        v-on="scope.itemEvents"
      >
        <q-item-section>
          <q-item-label>
            {{ scope.opt.name }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
  </lwf-autocomplete>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import LwfAutocomplete from 'components/core/LwfAutocomplete'
import { modalCustomer } from '@/utils/ui/modal'
import { ACCOUNT_RIGHT_CREATE_CUSTOMER } from '@/consts/rights'
import propsReadonly from '@/mixins/propsReadonly'
import validateProxyMixin from '@/mixins/validateProxyMixin'

const storeUser = createNamespacedHelpers('user')
const storeAgency = createNamespacedHelpers('user/agency')
export default {
  name: 'AutocompleteClient',
  components: { LwfAutocomplete },
  mixins: [propsReadonly, validateProxyMixin],
  props: {
    value: {
      type: [String, Object, Array],
      default: undefined
    },
    /**
     * Autorise l'ajout de client
     **/
    allowAdd: Boolean
  },
  computed: {
    ...storeUser.mapGetters({
      isGranted: 'isGranted'
    }),
    ...storeAgency.mapGetters({
      customers: 'customers'
    }),
    vOn () {
      const on = {}
      if (this.allowAdd && this.isGranted(ACCOUNT_RIGHT_CREATE_CUSTOMER)) {
        on.ajouter = this.onAjouter
      }
      return on
    },
    vListeners () {
      return {
        ...this.$listeners,
        ...this.vOn
      }
    },
    vAttrs () {
      return {
        label: 'Client',
        ...this.$attrs
      }
    }
  },
  methods: {
    onAjouter () {
      modalCustomer()
    }
  }
}
</script>

<style scoped>

</style>
